import React from 'react';

const WA_LINK = "https://chat.whatsapp.com/HxBfbxuBabo9BVEYJPbj3c?mode=gi_t";
const API = process.env.REACT_APP_BACKEND_URL;

export default function WALink({ children, className, source = 'page', 'data-testid': testId, ...props }) {
  const handleClick = () => {
    // PostHog tracking
    if (window.posthog) {
      window.posthog.capture('whatsapp_community_click', {
        source,
        timestamp: new Date().toISOString(),
        page: window.location.pathname,
      });
    }
    // Backend tracking (silent fail)
    fetch(`${API}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ source, page: window.location.pathname, event_type: 'whatsapp_click' }),
    }).catch(() => {});
  };

  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={className}
      data-testid={testId}
      {...props}
    >
      {children}
    </a>
  );
}
